import { Box, CardMedia, Tooltip } from "@mui/material";
import Smile from "assets/images/smiley_icon.svg";

const SmileyIcon = () => {
    return  <Box sx={{ cursor: "pointer" }}>
                <Tooltip title="We removed the paywall for you!">
                    <CardMedia sx={{
                        color: "yellow",
                        width: "2rem",
                        }}
                        component={"img"} src={Smile}
                    />
                </Tooltip>
            </Box>             
;
};

export default SmileyIcon;